const EMPLOYEES_MOVEMENT_TABLE_READY = "employeesMovement-table-ready"
const SEARCH_TEXT_STATE = "employeesMovement-table-search-text-state"
const ROWS_PER_PAGE_STATE = "employeesMovement-table-rows-per-page-state"
const PAGINATION_STATE = "employeesMovement-table-pagination-state"

const EMPLOYEE_DATA_FOR_ACTION = "employeesMovement-employee-data-for-action"


const ADD_EMPLOYEE_MOVEMENT_READY = "employeesMovement-table-add-employeesMovement-ready"


const PREVIOUS_EMPLOYEES_MOVEMENT_FILTER_START_DATE = "hr-tickets-previous-start-date"
const PREVIOUS_EMPLOYEES_MOVEMENT_FILTER_END_DATE = "hr-tickets-previous-end-date"

const initialState = {
    isEmployeesMovementTableReady: true,
    isAddEmployeeMovementReady: true,
    employeesMovement: {},


    previousFilterStartDate: "",
    previousFilterEndDate: "",
    
    employeeSelectedData: {},
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EMPLOYEES_MOVEMENT_TABLE_READY:
            return Object.assign({}, state, { isEmployeesMovementTableReady: action.payload })

        case ADD_EMPLOYEE_MOVEMENT_READY:
            return Object.assign({}, state, { isAddEmployeeMovementReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)


        case PREVIOUS_EMPLOYEES_MOVEMENT_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_EMPLOYEES_MOVEMENT_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        case EMPLOYEE_DATA_FOR_ACTION:
            return Object.assign({}, state, {employeeSelectedData:action.payload})

        default:
        return state
    
    }

}

export function employeesMovementTableReady(data) {
    return {
        type: EMPLOYEES_MOVEMENT_TABLE_READY,
        payload: data
    }
}

export function addEmployeeMovementReady(data) {
    return {
        type: ADD_EMPLOYEE_MOVEMENT_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function employeesMovementDataForAction(employeesMovementId){
    return{
        type:EMPLOYEE_DATA_FOR_ACTION,
        payload:employeesMovementId
    }
}


export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_EMPLOYEES_MOVEMENT_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_EMPLOYEES_MOVEMENT_FILTER_END_DATE,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/Employees Movement/redux/employeesmovement.js